<template>
  <h4>You are in home.</h4>
</template>

<script>
import newsHomeService from "../providers/newsHomeService";
export default {
  data() {
    return {
      newsData: [],
    };
  },
  computed: {
    buildParams() {
      const params = new URLSearchParams();
      params.append("subject", 1);
      params.append("content", 1);
      params.append("country", 1);
      return params;
    },
  },
  methods: {
    fetchNews() {
      this.newsData = [];
      newsHomeService
        .getAllCache(this.buildParams)
        .then((response) => {
          this.newsData = response.latestNews;
        })
        .catch((error) => console.log(error));
    },
  },
};
</script>

<style>
</style>